import React, { forwardRef, ReactNode } from 'react'
import { Button, ButtonProps, Spinner } from 'react-bootstrap'
import { Link } from 'react-router-dom'

interface IProps {
    processing?: boolean
    icon?: string
    link?: string
    hrefBlank?: boolean;
}

export const AdvancedButton = forwardRef<HTMLButtonElement, IProps & ButtonProps>(({ children, processing, disabled, icon, link, href, hrefBlank, className, ...rest }, ref) => {
    let prefix: ReactNode | null = null;
    if (processing) {
        prefix = <Spinner size='sm' />
    } else if (icon) {
        prefix = <i className={`bi ${icon}`} />
    }

    const btnClassName = `${className ? className : ''} ${children ? '' : 'btn-slim'}`.trim();

    const renderButton = () => (
        <Button {...rest} ref={ref} disabled={processing || disabled}
            className={btnClassName}
        >
            <div className='center gap-2'>{prefix} {children}</div>
        </Button>
    );

    if (link) {
        return <Link to={link} className='text-decoration-none'>
            {renderButton()}
        </Link>
    }

    if (href) {
        return (
            <a
                href={href}
                {...(hrefBlank ? { target: "_blank", rel: "noreferrer" } : {})}
                className={`text-decoration-none`}
            >
                {renderButton()}
            </a>
        );
    }

    return renderButton();
})
